export enum TerminalWsMethods {
  EcTerminalStatusChanged = 'EcTerminalStatusChanged',
  WorkerStatusChanged = 'WorkerStatusChanged',
}
